import React from 'react';
import { useAuth } from '../../components/auth/AuthContext';
import { ShoppingCart, Clock, CheckCircle, AlertCircle, PlusCircle } from 'lucide-react';
export function Dashboard() {
  const {
    user
  } = useAuth();
  // Mock data for demonstration
  const stats = [{
    name: 'Active Orders',
    value: 2,
    icon: <Clock className="h-6 w-6 text-primary" data-id="element-776" />,
    color: 'bg-primary/10'
  }, {
    name: 'Completed Orders',
    value: 5,
    icon: <CheckCircle className="h-6 w-6 text-primary" data-id="element-777" />,
    color: 'bg-primary/10'
  }, {
    name: 'Total Orders',
    value: 7,
    icon: <ShoppingCart className="h-6 w-6 text-primary" data-id="element-778" />,
    color: 'bg-primary/10'
  }];
  const upcomingAppointments = [{
    id: 1,
    service: 'Painting Service',
    date: 'May 15, 2023',
    time: '10:00 AM - 2:00 PM',
    status: 'Scheduled',
    vendor: 'ABC Painting Co.'
  }, {
    id: 2,
    service: 'Waterproofing',
    date: 'May 22, 2023',
    time: '9:00 AM - 12:00 PM',
    status: 'Pending Confirmation',
    vendor: 'WaterGuard Solutions'
  }];
  return <div data-id="element-779">
      <h1 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-780">Dashboard</h1>
      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-781">
        {stats.map((stat, index) => <div key={index} className="bg-white rounded-lg shadow p-6 flex items-center" data-id="element-782">
            <div className={`${stat.color} p-3 rounded-full mr-4`} data-id="element-783">
              {stat.icon}
            </div>
            <div data-id="element-784">
              <p className="text-sm text-gray-500" data-id="element-785">{stat.name}</p>
              <p className="text-2xl font-bold" data-id="element-786">{stat.value}</p>
            </div>
          </div>)}
      </div>
      {/* Recent Activity */}
      <div className="bg-white rounded-lg shadow mb-8" data-id="element-787">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-788">
          <h2 className="text-lg font-medium text-gray-900" data-id="element-789">
            Upcoming Appointments
          </h2>
        </div>
        <div className="divide-y divide-gray-200" data-id="element-790">
          {upcomingAppointments.length > 0 ? upcomingAppointments.map(appointment => <div key={appointment.id} className="p-6" data-id="element-791">
                <div className="flex justify-between items-start" data-id="element-792">
                  <div data-id="element-793">
                    <h3 className="font-medium text-gray-900" data-id="element-794">
                      {appointment.service}
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-795">
                      {appointment.vendor}
                    </p>
                  </div>
                  <span className={`px-2 py-1 text-xs rounded-full ${appointment.status === 'Scheduled' ? 'bg-primary/10 text-primary' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-796">
                    {appointment.status}
                  </span>
                </div>
                <div className="mt-2 flex items-center text-sm text-gray-500" data-id="element-797">
                  <Clock className="h-4 w-4 mr-1 text-primary" data-id="element-798" />
                  {appointment.date}, {appointment.time}
                </div>
              </div>) : <div className="p-6 text-center text-gray-500" data-id="element-799">
              No upcoming appointments
            </div>}
        </div>
      </div>
      {/* Quick Actions */}
      <div className="bg-white rounded-lg shadow" data-id="element-800">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-801">
          <h2 className="text-lg font-medium text-gray-900" data-id="element-802">Quick Actions</h2>
        </div>
        <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-803">
          <button className="flex items-center justify-center px-4 py-3 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors" data-id="element-804">
            <PlusCircle className="h-5 w-5 mr-2" data-id="element-805" />
            Request New Service
          </button>
          <button className="flex items-center justify-center px-4 py-3 border border-primary text-primary rounded-md hover:bg-primary/10 transition-colors" data-id="element-806">
            <ShoppingCart className="h-5 w-5 mr-2" data-id="element-807" />
            View My Orders
          </button>
          <button className="flex items-center justify-center px-4 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" data-id="element-808">
            <AlertCircle className="h-5 w-5 mr-2" data-id="element-809" />
            Report an Issue
          </button>
        </div>
      </div>
    </div>;
}